import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { NzModalService } from "ng-zorro-antd/modal";
import {
  MobileRegisterParams,
  EmailRegisterParams,
  MobileResetPWParams,
  EmailResetPWParams,
  SendResetEmialParams,
  SubmitOperatorParams,
  LoginParams,
  MobileLoginParams,
  IResetPassword,
  HttpResponseInterface,
  ExcelTaskParams,
  EmailLoginParams
} from "@root/router/login/http-interface";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs";

const MOBILE_CODE_API = "/api/operator_user/mobile_code";
const EMAIL_CODE_API = "/api/operator_user/email_code";
const MOBILE_REGISTER_API = "/api/operator_user/mobile_register";
const EMAIL_REGISTER_API = "/api/operator_user/email_register";
const RESET_PASSWORD_API = "/api/operator_user/reset_password_online";
const MOBILE_RESET_PASSWORD_API = "/api/operator_user/mobile_reset_password";
const SEND_RESET_EMAIL_API = "/api/operator_user/send_reset_email";
const EMAIL_RESET_PASSWORD_API = "/api/operator_user/email_reset_password";
const SUBMIT_OPERATOR_API = "/api/operator_user/submit_operator";
const LOGIN_API = "/api/v2/user/login";
const MOBILE_LOGIN_API = "/api/operator_user/mobile_login";
const EMAIL_LOGIN_API = "/api/operator_user/email_login";
const LOGOUT_API = "/api/operator_user/logout";
// v2
const GET_CODE_API = "/api/v2/user/get_code";
const REGISTER_API = "/api/v2/user/register";
const SET_PASSWORD_API = "/api/v2/user/set_password";
const OFFICALACCOUNT_GET_QRCODE = "/api/wechat/officialaccount/get_qrcode";

// v2.3.3
const RESET_ACCOUNT_API = "/api/v2/user/account_reset";
const EXCEL_API = "/api/operator_user/excel_task";

const USER_GUID_RESULT_API = "/api/user/registration_process";

// v2.7.2
const GET_CITY_INFO_API = '/api/v2/misc/city';
// const RESET_PASSWORD_V2_API = '/api/operator_user/reset_password'
const RESET_PASSWORD_V2_API = '/api/v3/user/password_reset'

@Injectable({
  providedIn: "root"
})
export class LoginService {
  private readonly CompanyLogoutApi = '/api/group_company/operator/logout';
  logout$ = new Subject();
  constructor(private http: HttpClient, private modalService: NzModalService) { }

  /** @deprecated */
  getOfficalAccount_get_qrcode() {
    return this.http.get(OFFICALACCOUNT_GET_QRCODE) as Observable<
      HttpResponseInterface
    >;
  }
  getCode(params) {
    const query = new HttpParams()
      .append("action_type", params.action_type)
      .append("account", params.account)
      .append("account_type", params.account_type)
      .append("image_code", params.image_code)
      .append("locale", params.locale)
    return this.http.get(GET_CODE_API, { params: query }) as Observable<
      HttpResponseInterface
    >;
  }

  setPassword(params) {
    return this.http.post(SET_PASSWORD_API, {
      ...params
    }) as Observable<HttpResponseInterface>;
  }

  // 2.3.3修改邮箱手机账号
  resetAccount(params) {
    return this.http.post(RESET_ACCOUNT_API, {
      ...params
    }) as Observable<HttpResponseInterface>;
  }

  register(params) {
    return this.http.post(REGISTER_API, {
      ...params
    }) as Observable<HttpResponseInterface>;
  }

  getMobileCode(params) {
    const query = new HttpParams()
      .append("mobile", params.mobile)
      .append("image_code", params.image_code)
      .append("type", params.type)
      .append("hideError", "No show Error");
    return this.http.get(MOBILE_CODE_API, { params: query }) as Observable<
      HttpResponseInterface
    >;
  }

  getEmailCode(params) {
    const query = new HttpParams()
      .append("email", params.email)
      .append("type", params.type)
      .append("image_code", params.image_code)
      .append("hideError", "No show Error");
    return this.http.get(EMAIL_CODE_API, { params: query }) as Observable<
      HttpResponseInterface
    >;
  }

  resetPassword(params) {
    return this.http.post(RESET_PASSWORD_V2_API, params) as Observable<HttpResponseInterface>;
  }

  /**
   * 手机注册接口
   * @param params MobileRegisterParams
   */
  mobileRegister(params: MobileRegisterParams) {
    return this.http.post(MOBILE_REGISTER_API, {
      ...params
    }) as Observable<HttpResponseInterface>;
  }
  /**
   * 邮箱注册接口
   * @param params EmailRegisterInterface
   */
  emailRegister(params: EmailRegisterParams) {
    return this.http.post(EMAIL_REGISTER_API, {
      ...params
    });
  }

  // 登录状态下修改密码
  resetPasswordOnline(params: IResetPassword) {
    return this.http.post(RESET_PASSWORD_API, {
      ...params
    });
  }

  /**
   * 手机重置密码
   * @param params MobileRegisterInterface
   */
  mobileResetPassword(params: MobileResetPWParams) {
    return this.http.post(MOBILE_RESET_PASSWORD_API, {
      ...params
    });
  }
  /**
   * 发送重置密码邮件
   * @param params ResetPasswordInterface
   */
  sendResetEmail(params: SendResetEmialParams) {
    return this.http.post(SEND_RESET_EMAIL_API, {
      ...params
    });
  }
  /**
   * 邮箱重置密码
   * @param params ResetPasswordInterface
   */
  emailResetPassword(params: EmailResetPWParams) {
    return this.http.post(EMAIL_RESET_PASSWORD_API, {
      ...params
    });
  }

  submitOperator(params: SubmitOperatorParams) {
    return this.http.post(SUBMIT_OPERATOR_API, {
      ...params
    });
  }

  /**
   * 登录接口
   * @param params LoginInterface
   */
  login(params: LoginParams) {
    return this.http.post(LOGIN_API, {
      ...params
    }) as Observable<HttpResponseInterface>;
  }
  /**
   * 手机验证登录
   */
  mobileLogin(params: MobileLoginParams) {
    return this.http.post(MOBILE_LOGIN_API, {
      ...params
    });
  }

  emailLogin(params: EmailLoginParams) {
    return this.http.post(EMAIL_LOGIN_API, params);
  }

  fetchUserGuidResult() {
    const query = new HttpParams().append("origin", "web");
    return this.http.get(USER_GUID_RESULT_API, { params: query }) as Observable<
      any
    >;
  }

  // checkIfCompleteUserGuid() {
  //   this.fetchUserGuidResult().subscribe(res => {
  //     if (res.error_code !== 0) {
  //       return;
  //     }
  //     const data = res.data || {};
  //     const { basic_info, custom_service, official_account, start } = data;
  //     if (custom_service && basic_info && start) {
  //       return;
  //     }
  //
  //     this.modalService.create({
  //       nzContent: UserGuidComponent,
  //       nzWidth: 700,
  //       nzMaskClosable: false,
  //       nzClosable: false,
  //       nzFooter: null,
  //       nzClassName: "host-index-user-guid-modal",
  //       nzComponentParams: {
  //         stepInfo: data
  //       }
  //     });
  //   });
  // }

  getCityInfo() {
    return this.http.get(GET_CITY_INFO_API);
  }

  /**
   * 退出接口
   * TODO: 添加一下清理工作
   */
  logout() {
    return this.http.post(LOGOUT_API, null);
  }

  companyLogout() {
    return this.http.post(this.CompanyLogoutApi, null);
  }
  /** 轮询表格导出任务接口 */
  exportExcel(params: ExcelTaskParams) {
    const query = new HttpParams().append("task_id", `${params.task_id}`);
    return this.http.get(EXCEL_API, { params: query }) as Observable<
      HttpResponseInterface
    >;
  }

  /** 通知退出消息，组件可订阅该消息，用于清理工作 */
  notifyLogout () {
    this.logout$.next();
  }
}
